<template>
    <div class="deck-card-regular" @click.self="viewCards()">
        <div class="deck-card-regular__image" @click="viewCards()">
            <img class="img-fluid" :src="cardDeck.central_image" @load="imageLoaded" @error="imageError" />
            <div v-if="!communityCard && cardDeck.shared_on_community" class="deck-card-regular__status-badge">
                <inline-svg src="/assets/img/icons/share-06-white.svg"></inline-svg>
                {{ cardDeck.deck_copied ? 'From Community Library' : 'Shared in Community'}}
            </div>
            <div v-else-if="!communityCard && cardDeck.deck_approval && cardDeck.deck_approval.status === 'pending'" class="deck-card-regular__status-badge in-review">
                <inline-svg src="/assets/img/icons/share-06-white.svg"></inline-svg>
                In Review
            </div>
        </div>
        <div class="d-flex flex-row w-100 align-items-center justify-content-between gap-2" style="margin-top: 24px;">
            <span class="deck-card-regular__date">Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}}</span>
            <avatar-group v-if="!communityCard && cardDeck.assigned_heroes"
                          size="xs"
                          :users="cardDeck.assigned_heroes"
                          @addToMagnusCards="$emit('onAssignCardDeck')">
            </avatar-group>
        </div>
        <div class="flex-1 w-100" @click="viewCards">
            <div class="deck-card-regular__title mt-2">
                {{ cardDeck.title }}
            </div>
            <div class="d-flex flex-row w-100 justify-content-between mt-2">
                <div class="d-flex gap-1">
                    <span class="deck-card-regular__category-label">{{cardDeck.category ? cardDeck.category.label : ''}}</span>
                    <span class="deck-card-regular__category-label cards-counter">
                        {{ cardDeck.cards.length }} {{ cardDeck.cards.length === 1 ? 'card' : 'cards'}}
                    </span>
                </div>
            </div>
        </div>
        <div v-if="!hideButtons" class="d-flex flex-column justify-content-end w-100 mt-2">
            <div v-if="communityCard" class="d-flex flex-row gap-1">
                <btn class="btn-primary flex-1" @click="addToMyCardDecks">
                    <inline-svg src="/assets/img/icons/file-plus-01.svg" class="me-1"></inline-svg>
                    Add to my Card Decks
                </btn>
                <div class="deck-card-regular__favorite" :class="{ 'selected': cardDeck.is_favorite }"
                     @click="toggleFavorite()"
                >
                    {{cardDeck.favorites_count ? cardDeck.favorites_count : '' }}
                    <inline-svg src="/assets/img/icons/heart-rounded.svg"></inline-svg>
                </div>
            </div>
            <div v-else class="d-flex flex-row gap-1">
                <btn class="btn-primary w-100"
                     style="flex: 1;"
                     @click="$emit('onAssignCardDeck')"
                >
                    Share with Heroes
                </btn>
                <tippy
                        :ref="'cardMenu'"
                        trigger="click"
                        placement="bottom"
                        :arrow="false"
                        :interactive="true"
                        theme="light"
                >
                    <div>
                        <a href="#" class="dropdown-menu__menu-item" @click.prevent="viewCards">
                            <inline-svg src="/assets/img/icons/eye.svg"></inline-svg>
                            View
                        </a>
                        <a href="#" class="dropdown-menu__menu-item" @click.prevent="editCardDeck">
                            <inline-svg src="/assets/img/icons/edit-04.svg"></inline-svg>
                            Edit
                        </a>
                        <a v-if="cardDeck.deck_copied" href="#" class="dropdown-menu__menu-item" @click.prevent="removeFromMyCardDecks">
                            <inline-svg src="/assets/img/icons/trash-01.svg"></inline-svg>
                            Remove from My Card Decks
                        </a>
                        <a v-else href="#" class="dropdown-menu__menu-item" @click.prevent="deleteCard">
                            <inline-svg src="/assets/img/icons/trash-01.svg"></inline-svg>
                            Delete
                        </a>
                        <template v-if="!cardDeck.deck_copied">
                            <a v-if="cardDeck.shared_on_community || (cardDeck.deck_approval && cardDeck.deck_approval.status === 'pending')"
                               href="#" class="dropdown-menu__menu-item"
                               @click.prevent="removeFromCommunityLibrary">
                                <inline-svg src="/assets/img/icons/remove.svg"></inline-svg>
                                Remove from Community Library
                            </a>
                            <a v-else-if="!cardDeck.parent_id && (!cardDeck.deck_approval || (cardDeck.deck_approval && cardDeck.deck_approval.status !== 'pending'))"
                               href="#" class="dropdown-menu__menu-item"
                               @click.prevent="shareOnCommunityLibrary">
                                <inline-svg src="/assets/img/icons/globe-02.svg"></inline-svg>
                                Share on Community Library
                            </a>
                        </template>
                    </div>
                    <template #trigger>
                        <btn class="btn-outline-light white">
                            <inline-svg height="20" src="/assets/img/icons/dots-vertical.svg"></inline-svg>
                        </btn>
                    </template>
                </tippy>
            </div>
        </div>
    </div>
</template>

<script>

import MenuDropdown from "@/components/theme/MenuDropdown.vue";
import MenuItem from "@/components/theme/MenuItem.vue";
import { tippy } from "vue-tippy";
import AvatarGroup from "@/components/AvatarGroup.vue";
import HeroSelect from "@/components/HeroSelect.vue";

export default {
  name: 'DeckCardRegular',
  props: ['hideButtons', 'communityCard', 'cardDeck'],
  components: {HeroSelect, AvatarGroup, MenuItem, MenuDropdown},
  data() {
    return {
      loading: {
        delete: false,
      },
        imageExists: false,
      favorite: false,
    }
  },
  methods: {
    viewCards() {
      if (this.communityCard) {
        this.$router.push({name: 'card.deck.cards', params: {id: this.cardDeck.id}})
      } else {
        this.$refs['cardMenu'].tip.hide();
        this.$emit('onViewCards', this.cardDeck)
      }
    },
    editCardDeck() {
      if (this.cardDeck.deck_copied) {
        this.$dialog.confirm('Please be aware that if you edit Card Deck taken from Community Library it will create a clone after you save the changes', {
        })
          .then(() => {
            this.$emit('onEditCardDeck');
            this.$refs['cardMenu'].tip.hide();
          });
      } else {
        this.$emit('onEditCardDeck');
        this.$refs['cardMenu'].tip.hide();
      }
    },
    deleteCard() {
      this.$dialog.confirm('Are you sure you want to delete Card Deck?', {
        okText: 'Yes',
        cancelText: 'No'
      })
        .then(() => {
          this.$http.post("/deck/delete", {id: this.cardDeck.id})
            .then((res) => {
              this.$events.emit('loadMyCardDecks');
            })
            .catch((error) => {
              console.log(error)
            });
        });
    },
    removeFromMyCardDecks() {
      const self = this;
      this.$dialog.confirm('Are you sure you want to remove this Card Deck from your Card Decks?', {
        okText: 'Yes',
        cancelText: 'No',
      }).then(() => {
        self.loading.delete = true;
        self.$http.post("/deck/remove-from-my-decks", {id: self.cardDeck.id, type: 'regular_deck'})
          .then(() => {
            self.$events.emit('loadMyCardDecks');
            self.loading.delete = false;
          })
          .catch(() => {
            self.loading.delete = false;
          });
      });
    },
    shareOnCommunityLibrary() {
      this.$dialog.confirm('Are you sure you want to share this Card Deck with the community?', {
        okText: 'Yes',
        cancelText: 'No'
      })
        .then(() => {
          this.$http.post("/deck/share-on-community", {id: this.cardDeck.id})
            .then((res) => {
              this.$events.emit('loadMyCardDecks');
              this.$modal.show('sharingConfirmationModal');
            })
            .catch((error) => {
              console.log(error)
            });
        });
    },
    removeFromCommunityLibrary() {
      this.$dialog.confirm('Are you sure you want to withdraw deck card from community"?', {
        okText: 'Yes',
        cancelText: 'No'
      })
        .then(() => {
          this.$http.post("/deck/remove-from-community", {id: this.cardDeck.id})
            .then((res) => {
              this.$events.emit('loadMyCardDecks');
            })
            .catch((error) => {
              console.log(error)
            });
        });
    },
    toggleFavorite() {
      let url = "/deck/add-favorite";
      if (this.cardDeck.is_favorite) {
        url = "/deck/remove-favorite"
      }
      this.$http.post(url, {deck_id: this.cardDeck.id})
        .then((res) => {
          this.$events.emit('loadCommunityCardDecks');
        })
        .catch((error) => {
          console.log(error)
        });
    },
    addToMyCardDecks() {
      this.$http.post("/deck/add-to-deck", {deck_id: this.cardDeck.id})
        .then((res) => {
          this.$events.emit('loadMyCardDecks');
        })
        .catch((error) => {
          console.log(error)
        });
    },
      imageLoaded() {
          this.imageExists = true;
      },
      imageError() {
          this.imageExists = false;
      },
  }
};

</script>
